import React, { useEffect, useState } from "react";
import { infoIcon, logo, logoGray, pendingIcon } from "../../../assets/images";
import Footer from "../../../Components/common/Footer";
import { useNavigate, useParams } from "react-router-dom";
import { GetUpgradeCheckoutData, paymentFailureService, paymentSuccessService } from "../../../api/Register";
import { formatToCurrency, loadScript } from "../../../utils/commonFunction";
import { GetPaymentData } from "../../../api/common";
import { RAZORPAY_KEY } from "../../../config/constant";
import { tostE, tostS, tostW } from "../../../config/tostConfig";
import Loading from "../../../Components/ui/Loading";

export default function Checkout() {
  const { user_id } = useParams();
  const [data, setData] = useState({});
  const navigate = useNavigate();
  const [check, setCheck] = useState(false);
  const [loading, setLoading] = useState(false);
  const [getDataLoading, setGetDataLoading] = useState(false);

  const getData = async () => {
    setGetDataLoading(true);
    try {
      const res = await GetUpgradeCheckoutData(user_id);
      if (res.status === 200 && res.data.success) {
        if(res.data && res.data.data && res.data.data.plan_history && res.data.data.plan_history.cancelled){
          navigate(`/application-cancelled/${user_id}`, { replace: true });
        }
        setData(res.data.data);
      }else if(res.data && res.data.data && res.data.data.plan_history && res.data.data.plan_history.cancelled){
        navigate(`/application-cancelled/${user_id}`, { replace: true });
      } else {
        navigate(`/payment-received`, { replace: true });
      }
    } catch (error) {
      console.log(error);
    } finally {
      setGetDataLoading(false);
    }
  }

  useEffect(() => {
    getData();
    loadScript("https://checkout.razorpay.com/v1/checkout.js");
  }, []); // eslint-disable-line


  const handleMakePayment = async () => {
    if (!check) {
      tostW("Please Confirm Details are correct");
      return
    }
    setLoading(true);
    try {
      const res = await GetPaymentData(user_id, data.total, "upgrade");
      if (res.status === 200 && res.data.success) {

        const respData = res.data.data;

        const options = {
          key: RAZORPAY_KEY, // Replace with your Razorpay key ID
          amount: respData.total_amount * 100, // Amount in the smallest currency unit (e.g., paise for INR)
          currency: 'INR',
          name: 'EEMA',
          description: 'Event & Entertainment Management Association',
          image: logo,
          order_id: respData.unique_order_id, // Replace with your generated order ID
          handler: async function (response) {
            const sendData = {
              ...response,
              history_id: data.plan_history.id,
              history_type: "upgrade"
            };
            setGetDataLoading(true);
            try {
              const res = await paymentSuccessService(sendData);
              if (res.status === 200 && res.data.success) {
                tostS(`Payment successful!`);
                navigate(`/app/upgrade/payment-success/${respData.unique_order_id}`, { replace: true });
              } else {
                tostE(res.message);
              }
            } catch (error) {
              tostE(error.message);
            } finally {
              setGetDataLoading(false);
            }
          },
          prefill: {
            name: respData.name,
            email: respData.email,
            contact: respData.mobile_number,
          },
          notes: {
            regarding: 'Upgrade Fee',
          },
          theme: {
            color: '#D37C51',
          },
        };
        console.log(options);
        const rzp = new window.Razorpay(options);
        rzp.on('payment.failed', async function (response) {
          setGetDataLoading(true);
          try {
            const res = await paymentFailureService({
              ...response.error,
              history_id: data.plan_history.id,
            });
            if (res.status === 200 && res.success) {
              tostE('Payment failed. Please try again.');
              console.log(response);
            }
          } catch (error) {
            console.log(error);
          } finally {
            setGetDataLoading(false);
          }
        });

        rzp.open();

      }
      // If payment link expired
      if(res.status === 200 && !res.data.success && res.data?.payment_link_expired){
        navigate(`/payment-expired`, { replace: true });
      }
    } catch (error) {
      tostE("Something went wrong");
    } finally {
      setLoading(false);
    }

  }

  return (
    <>
      {getDataLoading && <Loading />}
      <div className="customContainer">
        <div className="headingTexts ">
          <h2>Checkout</h2>
          <p>
            you are applying under{" "}
            <span style={{ fontWeight: "600" }}>{data.Plan_Name} Membership</span>
          </p>
        </div>

        <div className="row">
          <div className="col-md-7 col-lg-7 col-xl-7 col-xxl-7">
            <div className="orderDetails">
              <p>Please confirm your order details & click on continue.</p>
              <div className="userdetailsCard">
                {data.plan_history && <div className="dataRow">
                  <div>Member Name </div>
                  <div>{data.plan_history.company_name}</div>
                </div>}
                <div className="dataRow">
                  <div>Authorized Person </div>
                  <div>{data.Name}</div>
                </div>
                <div className="dataRow">
                  <div>Email </div>
                  <div>{data.Email}</div>
                </div>
                <div className="dataRow">
                  <div>Category </div>
                  <div>{data.Plan_Name}</div>
                </div>

                <div className="dataRow">
                  <div>
                    Joining Fee
                    <p style={{ fontSize: "12px", margin: 0 }}>(Difference Amount)</p>
                  </div>

                  <div className="tooltip-outer"><span style={{fontFamily:'arial'}}>₹ </span>{formatToCurrency(data.diff_Joining_Fees)}
                    <img className="amount_info_icon ms-2" src={infoIcon} alt="" />
                    <div className="tooltip_summary">
                      <div className="custom-tooltip-inner">
                        <div className="tooltip_data">
                          <div>{data.Plan_Name} Joining Fee </div>
                          <div><span style={{fontFamily:'arial'}}>₹ </span>{formatToCurrency(data.Joining_Fees)}</div>
                        </div>
                        <div className="tooltip_data">
                          <div>{data.Pervious_Plan_Name} Joining Fee </div>
                          <div>- <span style={{fontFamily:'arial'}}>₹ </span>{formatToCurrency(data.Pervious_Joining_Fees)}</div>
                        </div>
                        <hr className="mb-2 mt-2" />
                        <div className="tooltip_data fw-semibold">
                          <div>Difference Amount</div>
                          <div><span style={{fontFamily:'arial'}}>₹ </span>{formatToCurrency(data.diff_Joining_Fees)}</div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
                <div className="dataRow">
                  <div>Annual Fee </div>
                  <div><span style={{fontFamily:'arial'}}>₹ </span>{formatToCurrency(data.Annual_Fees)}</div>
                </div>
                <div className="dataRow">
                  <div>GST (18%)</div>
                  <div><span style={{fontFamily:'arial'}}>₹ </span>{formatToCurrency(data.gst)}</div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-5 col-lg-5 col-xl-4 offset-xl-1 col-xxl-4 offset-xxl-1">
            <div className="text-end">
              {" "}
              <img src={logoGray} alt="" />{" "}
            </div>

            <div className="totalAmount">
              <div>
                {" "}
                <strong><span style={{fontFamily:'arial'}}>₹ </span>{formatToCurrency(data.total)}</strong>
              </div>
              <p>Amount Payable</p>
            </div>
          </div>
        </div>
      </div>
      <Footer
        hideBackButton
        className="justify-content-end"
        isNextAllowed={!loading}
        isBackAllowed={false}
        nextButtonText="Make Payment"
        nextButtonAction={() => { setCheck(true) }}
      />
      {check && (
        <div className={"modal fade show confirmationModal"} style={{ display: "block" }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className={"modal-header "}>
                <h5 className="modal-title">Confirm</h5>
                <button
                  type="button"
                  className="close"
                  onClick={() => { setCheck(false) }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20.055"
                    height="20.055"
                    viewBox="0 0 20.055 20.055"
                  >
                    <path
                      id="Icon_metro-cross"
                      data-name="Icon metro-cross"
                      d="M19.424,15.592h0l-5.16-5.16,5.16-5.16h0a.533.533,0,0,0,0-.752L16.986,2.083a.533.533,0,0,0-.752,0h0l-5.16,5.16-5.16-5.16h0a.533.533,0,0,0-.751,0L2.726,4.521a.533.533,0,0,0,0,.751h0l5.16,5.16-5.16,5.16h0a.533.533,0,0,0,0,.751l2.437,2.437a.533.533,0,0,0,.752,0h0l5.16-5.16,5.16,5.16h0a.533.533,0,0,0,.751,0l2.437-2.437a.533.533,0,0,0,0-.751Z"
                      transform="translate(-1.047 -0.405)"
                      fill="#333"
                      stroke="#fff"
                      strokeWidth="3"
                    />
                  </svg>
                </button>
              </div>
              <div className="modal-body">
                <div className="text-center">
                  <img className="mb-3" src={pendingIcon} alt="" />
                  <p>By clicking Proceed, I hereby confirm the accuracy of details given above.</p>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className={"btn back btn-primary"}
                  onClick={() => { setCheck(false) }}
                >
                  Review
                </button>
                <button
                  type="button"
                  className={"btn backbtn btn-primary"}
                  onClick={() => { handleMakePayment() }}
                  disabled={loading}
                >
                  Proceed
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
